import reducer from './reducers';

import * as mappingActions from './actions';

export {
  mappingActions,
};

export default reducer;
